import {
    AG_GRID_COLUMN_AGGREGATION_FUNC,
    COLUMN_FORMATTING_TYPE,
} from '@/constants/common.constant'
import { ColumnAggMethod, ColumnFormat } from '@/enums/axiom-report.enum'
import { IReportsColumnDef } from '@/interfaces/gfpaReport.interface'
import { ColDef, ValueFormatterParams } from '@ag-grid-community/core'
import { GFPASecurityDetailsFieldsPrecision } from '@constants/gfpa.constant'
import { defaultColDefs } from '@utils/grid-utils/colDefs'
import { formatNumber } from '@utils/utils'
import {
    customDateComparator,
    formatCellValue,
    gridDateFormatter,
} from '../tableGridUtils'

export const getTableColumns = (
  columnsData: IReportsColumnDef[],
  deafultColumnsFieldsToShow: string[],
  fieldsToDisableRowGrouping: string[],
  detailsColumnsFieldsToDisplay: string[],
  detailsColumnsFieldsToHide: string[],
  columnConfig?: { [key: string]: any },
): ColDef[] => {
  const columns: ColDef[] = []
  columnsData?.forEach((item: IReportsColumnDef) => {
    if (
      detailsColumnsFieldsToDisplay.indexOf(item.name) !== -1 &&
      detailsColumnsFieldsToHide.indexOf(item.name) === -1
    ) {
      const formattingUnit = COLUMN_FORMATTING_TYPE[item.format.toLowerCase()]
      const precisionValue =
        GFPASecurityDetailsFieldsPrecision[item.name] ||
        GFPASecurityDetailsFieldsPrecision[item.name] === 0
          ? GFPASecurityDetailsFieldsPrecision[item.name]
          : 3
      let columnDef: ColDef = {
        ...{
          ...defaultColDefs,
          suppressMovable: false,
          lockPosition: false,
          suppressHeaderMenuButton: false,
        },
        field: item.name,
        headerName: item.header,
        headerTooltip: item.header,
        hide: !deafultColumnsFieldsToShow.includes(item.name),
      }
      if (columnConfig) {
        columnDef = { ...columnDef, ...columnConfig }
      }
      if (item.agg_method !== ColumnAggMethod.NONE) {
        columnDef.aggFunc =
          AG_GRID_COLUMN_AGGREGATION_FUNC[item.agg_method.toLowerCase()]
        // columnDef.tooltipValueGetter = (params) => params.value
        columnDef.enableRowGroup = fieldsToDisableRowGrouping.includes(
          item.name,
        )
          ? false
          : true
      }

      if (item.format === ColumnFormat.DATE) {
        columnDef.valueFormatter = (params) =>
          formatCellValue(params.value, item.format, item.header)
        columnDef.filter = 'agDateColumnFilter'
        columnDef.filterParams = {
          comparator: customDateComparator,
          buttons: ['reset'],
        }
        columnDef.tooltipValueGetter = gridDateFormatter
      } else if (formattingUnit || columnDef.aggFunc) {
        columnDef.tooltipField = undefined
        columnDef.valueFormatter = (params: ValueFormatterParams) =>
          formatCellValue(
            formatNumber(params.value, false, precisionValue, precisionValue),
            item.format,
          )

        columnDef.tooltipValueGetter = (params) => {
          let tooltipValue = params.value
          if (
            tooltipValue &&
            (typeof tooltipValue === 'number' ||
              typeof tooltipValue === 'object')
          ) {
            return formatCellValue(tooltipValue, item.format)
          }
          return tooltipValue
        }
      } else {
        columnDef.tooltipField = item.name
        columnDef.valueFormatter = (params) =>
          params.value && typeof params.value === 'number'
            ? formatNumber(params.value, false, precisionValue, precisionValue)
            : params.value
      }
      columns.push(columnDef)
    }
  })
  return columns
}

export const getColumnDetail = (
  key: string,
  reportType: string,
): IReportsColumnDef => {
  const columnsData =
    sessionStorage.getItem(reportType) &&
    JSON.parse(sessionStorage.getItem(reportType) as string)
  const columnDetail = columnsData?.find(
    (col: IReportsColumnDef) =>
      col.name === key && col.report_type === reportType,
  )
  return columnDetail || {}
}
